import { Box, Typography } from "@mui/material";
import {
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { COLORS } from "../../ui/Theme";
import useResponsive from "../hooks/useResponsive";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Tooltip from "@mui/material/Tooltip";
import { Close, MoreHoriz } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";

const CustomToolbar = ({ Form, tableTitle }) => {
    const [isShowAllTable, setIsShowAllTable] = useState(false);

    const { isMd } = useResponsive();
    const [searchParams, setSearchParams] = useSearchParams({});

    const currentFilter = searchParams.get("table") || false;

    useEffect(() => {
        if (currentFilter) setIsShowAllTable(true);
        else setIsShowAllTable(false);
    }, []);

    const handleSearchParams = () => {
        const newSearchParams = new URLSearchParams(searchParams);
        const filter = searchParams.get("table");

        if (filter) {
            newSearchParams.delete("table");
            setIsShowAllTable(false);
        } else {
            newSearchParams.set("table", "all");
            setIsShowAllTable(true);
        }

        setSearchParams(newSearchParams);
    };

    return (
        <GridToolbarContainer>
            <Grid2
                sx={{ width: "100vw" }}
                container
                spacing={2}
                justifyContent={"end"}
                alignItems={"center"}
            >
                <Grid2 xs={12} container alignItems={"center"}>
                    <Grid2 xs={12} md={8} lg={9} xl={10}>
                        <Box
                            sx={{
                                display: "flex",
                                gap: "10px",
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                {!isMd && (
                                    <Tooltip title={tableTitle.desc}>
                                        <ErrorOutlineIcon
                                            sx={{ fontSize: "20px", color: COLORS.BLUE }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Typography variant="h6" fontSize={"20px"}>
                                    {tableTitle.title}
                                </Typography>
                                {isMd && (
                                    <Typography color={"#9e9e9e"} fontSize={"12px"}>
                                        {tableTitle.desc}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Grid2>



                    <Grid2 xs={12} md={4} lg={3} xl={2}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <GridToolbarQuickFilter
                                variant="outlined"
                                size="small"
                                sx={{
                                    width: "100% !important",
                                    padding: "0px",
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: COLORS.SOFTGRAY,
                                        borderRadius: "12px !important",
                                        width: "100% !important",
                                        height: "40px",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "transparent",
                                    },
                                }}
                            />

                            <Box
                                sx={{
                                    width: "50px",
                                }}
                            >
                                <Tooltip
                                    title={
                                        isShowAllTable ? "بستن اطلاعات اضافی" : "نمایش کامل جدول"
                                    }
                                >
                                    <button
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        className={`btn ${isShowAllTable ? "btn-softred" : "btn-softblue"
                                            } btn-softblue`}
                                        onClick={handleSearchParams}
                                    >
                                        {isShowAllTable ? <Close /> : <MoreHoriz />}
                                    </button>
                                </Tooltip>
                            </Box>
                        </Box>
                    </Grid2>
                </Grid2>
                {Form && (
                    <Grid2 xs={12} sx={{ bgcolor: COLORS.INPUTBG, borderRadius: "12px" }}>
                        <Form />
                    </Grid2>
                )}
            </Grid2>
        </GridToolbarContainer>
    );
};

export default CustomToolbar;
